import { Button, Card, CardBody, Tab, Tabs, TabsBody, TabsHeader } from "@material-tailwind/react";
import moment from "moment";
import { useEffect, useState } from "react"
import insuranceServices from '../../../Services/insurance.services';
import pic from "../../images/dentalImg.png";
import { useNavigate } from "react-router-dom";
import fileServices from '../../../Services/file.service';
import statesService from "../../../Services/states.service";
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { sidebarStore } from "../../store/SidebarStore";

type StatusStyle = {
  badge: string;
  body: string;
  accent: string;
};

// Same colors the status pills used before this redesign, just centralized
// into one lookup instead of two duplicated ternary chains.
const STATUS_STYLES: Record<string, StatusStyle> = {
  ReadyToSend: {
    badge: "bg-yellow-500 text-primary-50",
    body: "bg-yellow-50",
    accent: "bg-yellow-500",
  },
  Sent: {
    badge: "bg-red-500 text-primary-50",
    body: "bg-red-50",
    accent: "bg-red-500",
  },
  "In Progress": {
    badge: "bg-green-500 text-primary-50",
    body: "bg-green-50",
    accent: "bg-green-500",
  },
  "Changes Requested": {
    badge: "bg-cyan-500 text-primary-50",
    body: "bg-cyan-50",
    accent: "bg-cyan-500",
  },
  FinalApproval: {
    badge: "bg-purple-500 text-primary-50",
    body: "bg-purple-50",
    accent: "bg-purple-500",
  },
  "Credential Complete": {
    badge: "bg-teal-500 text-primary-50",
    body: "bg-teal-50",
    accent: "bg-teal-500",
  },
};

const DEFAULT_STATUS_STYLE: StatusStyle = {
  badge: "bg-lime-500 text-primary-50",
  body: "bg-lime-50",
  accent: "bg-lime-500",
};

const getStatusStyle = (status: string): StatusStyle => STATUS_STYLES[status] ?? DEFAULT_STATUS_STYLE;

const InsuranceRequestView = (props: any) => {
  const [insuranceRequest, setInsuranceRequest] = useState([{
    'credentialRequestId': 0,
    'name': '',
    'message': '',
    'requestDate': '',
    'effectiveDate':'',
    'credStatus': 0,
    'insuranceStatus': '',
    'signedPdfAvailable':false,
    'signedPdfVaultId':0
  }]);

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [, setCanCreateNewRequest] = useState(false);
  
  useEffect(() => {
    getCredentialDashboard('all')
  }, [])

  useEffect(() => {
    const checkCanCreateNewRequest = async() => {
      const response = await statesService.GetCredentialNewRequestStatus();
      setCanCreateNewRequest(response.data);
      sidebarStore.setCanCreateNewRequest(response.data);
    }
    checkCanCreateNewRequest();
  },[])
  

  const getCredentialDashboard = async (value: any) => {
    setLoading(true)
    try {
      const result = await insuranceServices.GetDentistInsuranceRequest()

      if (value == 'all') {
        result.requestsAll.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
          item.effectiveDate = item.effectiveDate == null ? '' : moment(item.effectiveDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var resultAll = result.requestsAll;
        setInsuranceRequest(resultAll)
      }
      else if (value == 'inprogress') {
        result.requestsByStatus.InProgress.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var inProgress = result.requestsByStatus.InProgress;
        setInsuranceRequest(inProgress)
      }
      else if (value == 'readyToSend') {
        result.requestsByStatus.ReadyToSend.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var readyToSend = result.requestsByStatus.ReadyToSend;
        setInsuranceRequest(readyToSend)
      }
      else if (value == 'sent') {
        result.requestsByStatus.Sent.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var sent = result.requestsByStatus.Sent;
        setInsuranceRequest(sent)
      }
      else if (value == 'changesRequested') {
        result.requestsByStatus.ChangesRequested.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var changesRequested = result.requestsByStatus.ChangesRequested;
        setInsuranceRequest(changesRequested)
      }
      else if (value == 'insuranceCompanyFeedback') {
        result.requestsByStatus.InsuranceCompanyFeedback.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var insuranceCompanyFeedback = result.requestsByStatus.InsuranceCompanyFeedback;
        setInsuranceRequest(insuranceCompanyFeedback)
      }
      else if (value == 'finalApproval') {
        result.requestsByStatus.FinalApproval.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var finalApproval = result.requestsByStatus.FinalApproval;
        setInsuranceRequest(finalApproval)
      }
      else if (value == 'credentialComplete') {
        result.requestsByStatus.CredentialComplete.map((item: any) => {
          item.requestDate = moment(item.requestDate, "YYYYMMDD").format('MMM DD,YYYY')
          item.effectiveDate = moment(item.effectiveDate, "YYYYMMDD").format('MMM DD,YYYY')
        })
        var credentialComplete = result.requestsByStatus.CredentialComplete;
        setInsuranceRequest(credentialComplete)
      }

    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }

  const visbility = "";
  const stateManager = () => {
    setIsOpen(false)
  }
  const toggleState = () => {
    setIsOpen(true)
  }

  const moveToQuestionaries = (data: any) => {
    navigate('/createInsurance', { state: { data, isAdmin: false } })
  }

  const handleCredentialNewRequest = async () => {
    try {
      const response = await statesService.GetCredentialNewRequestStatus();
      if (response) {
        navigate("/credentialing"); 
      } else {
        toast.warning('You need to finish the questionnaire and payment for the current request.', { position: 'top-center' })
      }
    } catch (error) {
      console.error("Error checking request status:", error);
    }
  };

  const handleInsuranceEdit = async () => {
    navigate('/selectinsurance')
  }

  const handleNewRequest = async () => {
    navigate("/credentialing"); 
  }
  return (
    <div>
      <div className="mx-auto px-4 sm:px-8 flex-grow">
  <div className="py-5">
    {/* Flex container for heading and buttons */}
    <div className="flex flex-row items-center justify-between mb-4">
      <h1 className="text-2xl leading-tight sm:text-3xl">
        {props.heading}
      </h1>
      <div className={`flex space-x-4 ${visbility}`}>
        {/* <button
          className="px-4 py-2 bg-green-600 text-white font-semibold rounded-lg"
          onClick={() => handleCredentialNewRequest()}
        >
          Start New Request
        </button> */}
       {sidebarStore.canCreateNewRequest ? (
        <button
          className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg"
          onClick={() => handleNewRequest()}
        >
          New Credentialing Request
        </button>
      ) : (
        <button
          className="px-4 py-2 bg-green-600 text-white font-semibold rounded-lg"
          onClick={() => handleInsuranceEdit()}
        >
          Change Insurance Companies
        </button>
      )}
      </div>
    </div>
    <p>{props.subTitle}</p>
  </div>
</div>

      <Tabs value="html">
        <TabsHeader className="z-10">
          {props.data?.map(({ label, value }: any) => (
            <Tab key={value} value={value} onClick={() => { getCredentialDashboard(value) }}>
              {`${label}`}
            </Tab>
          ))}
        </TabsHeader>
        
        {loading ? (
          <div className="w-full flex justify-center items-center py-20">
            <svg
              aria-hidden="true"
              className="w-10 h-10 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        ) : (
        <TabsBody className="grid-cols-3 grid gap-2 ">
          {insuranceRequest.map((request) => {
            const statusStyle = getStatusStyle(request.insuranceStatus);
            return (
              <Card key={request.credentialRequestId} className="m-2 overflow-hidden">
                <div className={`h-1 w-full ${statusStyle.accent}`} />
                <CardBody className="p-4 flex flex-col gap-3">
                  <div className="flex flex-row justify-between items-start gap-2">
                    <div className="flex items-center">
                      <img className="w-18 h-12" src={pic} alt="logo" />
                      <div className="flex flex-col">
                        <button type="button" onClick={() => { moveToQuestionaries(request) }}>
                          <p className="text-[#222222] text-left">{request.name}</p>
                          <p className="text-[#5f635f] text-left">Started Date: {request.requestDate}</p>
                          {request.effectiveDate != '' && <p className="text-[#5f635f] text-left">Effective Date: {request.effectiveDate}</p>}
                        </button>
                      </div>
                    </div>
                    <span className={`shrink-0 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${statusStyle.badge}`}>
                      {request.insuranceStatus}
                    </span>
                  </div>

                  <div className={`p-3 rounded-lg min-h-[84px] ${statusStyle.body}`}>
                    <p className="text-sm text-[#5f635f]">{request.message}</p>
                  </div>
                  {request.signedPdfAvailable && <Button onClick={() => fileServices.getFile(request.signedPdfVaultId)}>Download</Button>}
                </CardBody>
              </Card>
            );
          })}
        </TabsBody>
        )}
        {/* <CreateInsuranceRequestPopup
          isOpen={isOpen}
          stateManager={stateManager}
          heading={"Create new Insurance Request"}
          description={"You are about to create a new insurance request, after selecting your state we will ask for the neccessory information in a few simple steps."}
          buttonName={"Create Insurance Request"}
          requireName={true}
        /> */}
      </Tabs>
    </div>
  )
}

export default InsuranceRequestView